'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openBiddableModal = exports.fetchEscrowAccount = exports.releaseEscrow = exports.getEscrowAccount = exports.isFetchingEscrow = exports.isReleasingEscrow = exports.RELEASE_ESCROW_SUCCESS = exports.RELEASE_ESCROW_FAIL = exports.RELEASE_ESCROW_REQUEST = exports.ESCROW_ACCOUNTS_SUCCESS = exports.ESCROW_ACCOUNTS_FAIL = exports.ESCROW_ACCOUNTS_REQUEST = exports.STATUS_LOCKED = exports.STATUS_RELEASED = exports.STATUS_RELEASING = exports.STATUS_CREATED = exports.STATUS_CREATING = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _escrow = require('../api/escrow');

var _user = require('./user');

var _helpers = require('../api/remote/helpers');

var _reselect = require('reselect');

var _catalog = require('./catalog');

var _config = require('./config');

var _intl = require('./intl');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _browser = require('./browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATUS_CREATING = exports.STATUS_CREATING = 'CreationPending';
var STATUS_CREATED = exports.STATUS_CREATED = 'CreationConfirmed';
var STATUS_RELEASING = exports.STATUS_RELEASING = 'ReleasePending';
var STATUS_RELEASED = exports.STATUS_RELEASED = 'ReleaseConfirmed';
var STATUS_LOCKED = exports.STATUS_LOCKED = 'Locked';

/* Action Types */
var ESCROW_ACCOUNTS_REQUEST = exports.ESCROW_ACCOUNTS_REQUEST = 'la/user/escrow/ESCROW_ACCOUNT_REQUEST';
var ESCROW_ACCOUNTS_FAIL = exports.ESCROW_ACCOUNTS_FAIL = 'la/user/escrow/ESCROW_ACCOUNT_FAIL';
var ESCROW_ACCOUNTS_SUCCESS = exports.ESCROW_ACCOUNTS_SUCCESS = 'la/user/escrow/ESCROW_ACCOUNT_SUCCESS';
var RELEASE_ESCROW_REQUEST = exports.RELEASE_ESCROW_REQUEST = 'la/user/escrow/RELEASE_ESCROW_REQUEST';
var RELEASE_ESCROW_FAIL = exports.RELEASE_ESCROW_FAIL = 'la/user/escrow/RELEASE_ESCROW_FAIL';
var RELEASE_ESCROW_SUCCESS = exports.RELEASE_ESCROW_SUCCESS = 'la/user/escrow/RELEASE_ESCROW_SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: null,
    escrowAccount: null,
    fetchingEscrowAccount: false,
    releasingEscrow: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case RELEASE_ESCROW_FAIL:
            return (0, _extends3.default)({}, state, {
                releasingEscrow: false
            });
        case RELEASE_ESCROW_SUCCESS:
            return (0, _extends3.default)({}, state, {
                escrowAccount: (0, _extends3.default)({}, state.escrowAccount, { status: STATUS_RELEASING }),
                releasingEscrow: false
            });
        case RELEASE_ESCROW_REQUEST:
            return (0, _extends3.default)({}, state, {
                releasingEscrow: true
            });
        case ESCROW_ACCOUNTS_FAIL:
            return (0, _extends3.default)({}, state, {
                error: action.payload,
                fetchingEscrowAccount: false
            });
        case ESCROW_ACCOUNTS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                escrowAccount: action.payload,
                fetchingEscrowAccount: false
            });
        case ESCROW_ACCOUNTS_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: null,
                fetchingEscrowAccount: true
            });
        default:
            return state;
    }
}

var getInstantDepositWidget = function getInstantDepositWidget() {
    return typeof window === 'undefined' ? false : window.InstantDepositWidget;
};

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.escrow;
};
var isReleasingEscrow = exports.isReleasingEscrow = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.releasingEscrow;
});
var isFetchingEscrow = exports.isFetchingEscrow = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.fetchingEscrowAccount;
});
var getEscrowAccount = exports.getEscrowAccount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.escrowAccount;
});

/* Action Creators */
var releaseEscrow = exports.releaseEscrow = function releaseEscrow(depositId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, isMobile, releasingEscrow, authToken, deployment, _ref2, success, error;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            isMobile = !!(0, _browser.isUiMobile)(state);
                            releasingEscrow = isReleasingEscrow(state);

                            if (!(isMobile || releasingEscrow)) {
                                _context.next = 5;
                                break;
                            }

                            return _context.abrupt('return');

                        case 5:
                            _context.prev = 5;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.next = 10;
                            return dispatch({ type: RELEASE_ESCROW_REQUEST });

                        case 10:
                            _context.next = 12;
                            return (0, _escrow.releaseEscrowDeposit)({ authToken: authToken, deployment: deployment, depositId: depositId });

                        case 12:
                            _ref2 = _context.sent;
                            success = _ref2.success;
                            error = _ref2.error;

                            if (!success) {
                                _context.next = 20;
                                break;
                            }

                            _context.next = 18;
                            return dispatch({ type: RELEASE_ESCROW_SUCCESS });

                        case 18:
                            _context.next = 22;
                            break;

                        case 20:
                            _context.next = 22;
                            return dispatch({ error: error, type: RELEASE_ESCROW_FAIL });

                        case 22:
                            _context.next = 28;
                            break;

                        case 24:
                            _context.prev = 24;
                            _context.t0 = _context['catch'](5);
                            _context.next = 28;
                            return dispatch({ error: _context.t0, type: RELEASE_ESCROW_FAIL });

                        case 28:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[5, 24]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};
var fetchEscrowAccount = exports.fetchEscrowAccount = function fetchEscrowAccount() {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, isMobile, authToken, bidderId, deployment, _ref4, error, payload, success;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            isMobile = !!(0, _browser.isUiMobile)(state);

                            if (!isMobile) {
                                _context2.next = 4;
                                break;
                            }

                            return _context2.abrupt('return');

                        case 4:
                            _context2.prev = 4;
                            authToken = (0, _user.getAuthToken)(state);
                            bidderId = (0, _user.getBidderId)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context2.next = 10;
                            return dispatch({ type: ESCROW_ACCOUNTS_REQUEST });

                        case 10:
                            _context2.next = 12;
                            return (0, _escrow.fetchEscrowAccountInfo)({ authToken: authToken, bidderId: bidderId, deployment: deployment });

                        case 12:
                            _ref4 = _context2.sent;
                            error = _ref4.error;
                            payload = _ref4.payload;
                            success = _ref4.success;

                            if (!success) {
                                _context2.next = 21;
                                break;
                            }

                            _context2.next = 19;
                            return dispatch({ payload: payload, type: ESCROW_ACCOUNTS_SUCCESS });

                        case 19:
                            _context2.next = 23;
                            break;

                        case 21:
                            _context2.next = 23;
                            return dispatch({ payload: error, type: ESCROW_ACCOUNTS_FAIL });

                        case 23:
                            _context2.next = 29;
                            break;

                        case 25:
                            _context2.prev = 25;
                            _context2.t0 = _context2['catch'](4);
                            _context2.next = 29;
                            return dispatch({ payload: _context2.t0, type: ESCROW_ACCOUNTS_FAIL });

                        case 29:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[4, 25]]);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
};
var openBiddableModal = exports.openBiddableModal = function openBiddableModal(catalogId, _callback) {
    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var state, _escrowSupported$getC, escrowSupported, _ref6, status, deployment, isMobile, hasEscrow, InstantDepositWidget, isProd, authToken, depositUrl, widget;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            _escrowSupported$getC = (0, _extends3.default)({ escrowSupported: true }, (0, _catalog.getCatalog)(state, catalogId)), escrowSupported = _escrowSupported$getC.escrowSupported;
                            _ref6 = getEscrowAccount(state) || {}, status = _ref6.status;
                            deployment = (0, _config.getDeployment)(state);
                            isMobile = !!(0, _browser.isUiMobile)(state);
                            hasEscrow = status && status !== STATUS_RELEASED;

                            if (!(!escrowSupported || hasEscrow || isMobile)) {
                                _context3.next = 8;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 8:
                            InstantDepositWidget = getInstantDepositWidget();

                            if (InstantDepositWidget) {
                                _context3.next = 11;
                                break;
                            }

                            return _context3.abrupt('return');

                        case 11:
                            isProd = deployment.includes('prod');
                            authToken = (0, _user.getAuthToken)(state);
                            depositUrl = (0, _helpers.buildUrl)('<ESCROW-API>', deployment, 'deposit');
                            widget = new InstantDepositWidget({
                                accountSettingsUrl: '/dashboard/profile?tab=instant-approval-deposit',
                                brandingCssOptions: {
                                    brandColor: '#0097BA',
                                    buttonBorderRadius: '2px'
                                },
                                callback: function callback() {
                                    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                                    var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                                    if (error && !(0, _isEmpty2.default)(error)) {
                                        console.error('an error occurred:', error);
                                    } else {
                                        var payload = result.result;

                                        dispatch(completeDeposit(payload));
                                    }

                                    _callback && _callback(result);
                                },
                                data: { catalogId: catalogId, token: authToken },
                                depositUrl: depositUrl,
                                expectedNetworkId: isProd ? '1' : '4', // 1 = Mainnet, 4 = Rinkeby (dev network)
                                // deployment === prod so we can test with a lower amount of real ETH in preprod
                                forcedUSDValue: deployment === 'prod' ? 1000 : undefined,
                                isGlobalApproval: true,
                                language: (0, _intl.getLocale)(state) || 'en',
                                platformName: 'LiveAuctioneers'
                            });

                            widget.openPopup();

                        case 16:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x7, _x8) {
            return _ref5.apply(this, arguments);
        };
    }();
};

var completeDeposit = function completeDeposit(_ref7) {
    var depositId = _ref7.depositId;
    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context4.prev = 3;
                            _context4.next = 6;
                            return (0, _escrow.completeEscrowDeposit)({ authToken: authToken, deployment: deployment, depositId: depositId });

                        case 6:
                            dispatch(fetchEscrowAccount());
                            _context4.next = 12;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](3);

                            console.error('an error occurred:', _context4.t0);

                        case 12:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined, [[3, 9]]);
        }));

        return function (_x11, _x12) {
            return _ref8.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/escrow.js
// module id = rfN8
// module chunks = 60